
<div class="wrapper-page">
  <div class="wrapper-likes-page lists">
    <tl-header></tl-header>
    <div class="likes-page">
      <div class="header-likes-page">
        <span class="title">
          {{'LIST_SINGLE_PAGE.likes' | translate}}
        </span>
        <div class="number-likes">
          <span>{{users.length}}</span>
        </div>
      </div>
      <div class="content-likes-page" #likesContainter (scroll)="onScroll()" style="overflow-y: auto; height: 100%;">
        <div *ngFor="let user of users" class="wrapper-user-liked">
         <div *ngIf="type === 'listReview' || type === 'itemReview'">
           <div [routerLink]="[PAGES_AND_PATHS.profile.pagePath, user.liker.username]" class="user-like-info">
             <img class="avatar-user" alt=""
                  [src]="user.liker.profile_photo_url !== null ? user?.liker.profile_photo_url : (user.liker.subscriptions | checkActiveRole) === UserRoles.expert ? '../../../assets/images/avatar-user-expert.png' : '../../../assets/images/avatar-user.png'">
             <span>{{user.liker.name}}</span>
             <img *ngIf="(user.liker.subscriptions | checkActiveRole) === UserRoles.expert" class="badge" src="../../../assets/icons/fill/icon-badge.svg" alt="">
             <img *ngIf="(user.liker.subscriptions | checkActiveRole) === UserRoles.company" src="../../../assets/icons/fill/icon-fill-company.svg" alt="">
           </div>
         </div>
          <div *ngIf="type === 'list' || type === 'item'">
            <div [routerLink]="[PAGES_AND_PATHS.profile.pagePath, user.username]" class="user-like-info">
              <img class="avatar-user" alt=""
                   [src]="user.profile_photo_url !== null ? user?.profile_photo_url : (user.subscriptions | checkActiveRole) === UserRoles.expert ? '../../../assets/images/avatar-user-expert.png' : '../../../assets/images/avatar-user.png'">
              <span>{{user.name}}</span>
              <img *ngIf="(user.subscriptions | checkActiveRole) === UserRoles.expert" class="badge" src="../../../assets/icons/fill/icon-badge.svg" alt="">
              <img *ngIf="(user.subscriptions | checkActiveRole) === UserRoles.company" src="../../../assets/icons/fill/icon-fill-company.svg" alt="">
            </div>
          </div>
          <div *ngIf="type === 'itemReview' || type === 'listReview'">
            <button *ngIf="user.liker.id !== authHelperService.getUserData.id"  (click)="followUnfollowUser(user.liker.id)" class="custom-btn custom-btn--outline">
              <span>{{user.liker.am_i_following_this_user ? ('CHAT.unfollow' | translate) : ('GENERAL.follow' | translate)}}</span>
            </button>
          </div>
          <div *ngIf="type === 'list' || type === 'item'">
            <button *ngIf="user.id !== authHelperService.getUserData.id"  (click)="followUnfollowUser(user.id)" class="custom-btn custom-btn--outline">
              <span>{{user.am_i_following_this_user ? ('CHAT.unfollow' | translate) : ('GENERAL.follow' | translate)}}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
